export default function IconCheckCircleChecked(props: Icon) {
  const { height, width, className } = props;
  return (
    <svg
      className={`icon-checked flex-shrink-0${
        className ? ` ${className}` : ""
      }`}
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 800 800"
    >
      <path
        fill="currentColor"
        d="M405.731-449.4,337.7-517.44q-13.732-13.726-34.268-13.73t-34.266,13.73Q255.43-503.7,255.7-483.173t14,34.277L369.846-348.759q15.42,15.22,35.983,15.225t35.786-15.225l207.55-207.549Q662.9-570.033,662.9-590.3t-13.732-34q-13.731-13.726-34.267-13.73t-34.267,13.73ZM460.782-99.218q-83.509,0-156.392-31.455t-126.8-85.361q-53.914-53.906-85.363-126.8T60.782-499.218q0-83.511,31.449-156.4t85.363-126.8q53.913-53.906,126.8-85.361t156.392-31.445q83.51,0,156.392,31.445t126.8,85.361q53.914,53.906,85.363,126.8t31.448,156.4q0,83.5-31.448,156.387t-85.363,126.8q-53.913,53.906-126.8,85.361T460.782-99.218Z"
        transform="translate(-60.782 899.218)"
      />
    </svg>
  );
}
